import React from "react";
import { Box, Card, Grid, Stack, Typography } from '@curves/ui-base';

import { formatCurrencyFn, parseCardExpiry } from "@Util/utils";
import { parseDate } from "@Util/moment.util";
const CyclePurchaseDetailOrder = props => {
	const { detailData } = props;
	const CyclePurchaseDetailInfo = [
		{
			key: "cycleOrderNo",
			text: "主單編號",
			value: detailData?.cycleOrderNo || "無資料",
		},
		{
			key: "cycleOrderTypeText",
			text: "訂單狀態",
			value: detailData?.cycleOrderTypeText || "無資料",
		},
		{
			key: "cycleOrderDate",
			text: "建單日期",
			value: detailData?.cycleOrderDate ? parseDate(detailData.cycleOrderDate) : "無資料",
		},
		{
			key: "updatedDate",
			text: "更新日期",
			value: detailData?.updatedDate ? parseDate(detailData.updatedDate) : "無資料",
		},
		{
			key: "shippingDayText",
			text: "出貨週期",
			value: detailData?.shippingDayText ? `${detailData.shippingDayText}日` : "無資料",
		},
		{
			key: "memberName",
			text: "訂購人",
			value: detailData?.memberName || "無資料",
		},
		{
			key: "saleAmount",
			text: "訂單金額",
			value: detailData?.saleAmount ? "$" + formatCurrencyFn(detailData.saleAmount) : "無資料",
		},
		{
			key: "cardExpiryDate",
			text: "信用卡效期",
			value: parseCardExpiry(detailData?.payment?.cardExpiryDate || "無資料"),
		},
		{
			key: "firstShipmentMonth",
			text: "首次出貨月",
			value: detailData?.firstShipmentMonth ? parseDate(detailData.firstShipmentMonth) : "無資料",
		},
		{
			key: "clubName",
			text: "所屬店鋪",
			value: detailData?.clubName || "無資料",
		},
		{
			key: "saleClubName",
			text: "販售店鋪",
			value: detailData?.saleClubName || "無資料",
		},
	];
	const handleValue = (value, formatter) => {
		if (!formatter) return value;
		if (typeof formatter === "function") return formatter(value);
	};
	return (
		<Card className="p-4">
			<Card.CardContent>
				<Grid spacing={2} container>
					{CyclePurchaseDetailInfo.map((item, i) => {
						const { key, text, value, formatter } = item;
						return (
							<Grid key={`${key}-${i}`} xs={6} lg={4} xl={3} item>
								<Grid spacing={2} container>
									<Grid xs={5} item>
										<Box>
											<Typography className="font-color-3">{text}</Typography>
										</Box>
									</Grid>
									<Grid xs={7} item>
										<Box>
											<Stack>{handleValue(value, formatter)}</Stack>
										</Box>
									</Grid>
								</Grid>
							</Grid>
						);
					})}
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default CyclePurchaseDetailOrder;
